<template>
  <v-overlay :style="{ 'backdrop-filter': pausedState ? 'blur(6px)' : '' }"
             :opacity="0.7"
             v-model="pausedState"
  >
    <paused-state :time="time" @break="takeBreak()" @quit="quit()" @resume="resume()"></paused-state>
  </v-overlay>
</template>

<script>
    import PausedState from "./PausedState";
    import applicationEventHub from "../../../events/applicationEventHub";
    export default {
        components: {
            PausedState,
        },
        name: "JourneyPausedOverlay",
        props: {
            time: {
                type: Number,
                default: 2
            }
        },
        computed: {
            pausedState() {
                return this.$store.state.journey.paused;
            }
        },
        data: () => ({
            current: 0,
            interval: null,
        }),
        methods: {
            resume(){
               this.$store.dispatch('journey/toggleJourneyPauseState', false);
               applicationEventHub.journeyPauseResumed();
            },
            takeBreak() {
              this.$store.dispatch('auth/startBreak');
            },
            quit() {
              this.$store.dispatch('auth/logout', {
                clearAssessmenttoken : false,
                navigate : true
              });
            },

        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
